import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, ButtonsWrapper, Form, TextInput } from '@thinknet-gmbh/platform-common-ui';

import { FormWrapper, EmailTemplateFormWrapper } from './email-template-form.styles';
import { IEmailTemplateFormProps } from './email-template-form.interfaces';
import JoinEditorInput from './components/jodit-editor-input/jodit-editor-input.component';
import PlaceholderList from './components/placeholder-list/placeholder-list.component';

const EmailTemplateForm: FC<IEmailTemplateFormProps> = ({ onClose, initialValues, onFinish }) => {
  const { t } = useTranslation(['settings', 'common']);

  return (
    <EmailTemplateFormWrapper>
      <Form
        className={'email-template-form'}
        layout="vertical"
        onFinish={values => onFinish({ ...values })}
        initialValues={initialValues}
      >
        <FormWrapper>
          <Form.Item
            name="subject"
            label={t('settings:emailTemplate.labels.subject')}
            rules={[
              { required: true, message: t('settings:emailTemplate.validation.subjectRequired') },
            ]}
          >
            <TextInput
              maxLength={50}
              placeholder={t('settings:emailTemplate.labels.typeSubjectName')}
            />
          </Form.Item>
          <Form.Item
            name="body"
            label={t('settings:emailTemplate.labels.body')}
            rules={[
              { required: true, message: t('settings:emailTemplate.validation.bodyRequired') },
            ]}
          >
            <JoinEditorInput />
          </Form.Item>
        </FormWrapper>
        <ButtonsWrapper marginTop={16}>
          <Button htmlType="submit" type="primary">
            {t('common:buttons.save')}
          </Button>
          <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
      <PlaceholderList />
    </EmailTemplateFormWrapper>
  );
};

export default EmailTemplateForm;
